import { type RefObject, useEffect, useRef, useState } from "react";
import type { PanelImperativeHandle } from "react-resizable-panels";
import { DEFAULT_TAGS_TABLE_HEIGHT } from "../utils/tagsTableSize";

const SIZE_TOLERANCE_PX = 1;

export const useDefaultTagsTableHeight = (
	panelRef: RefObject<PanelImperativeHandle | null>,
) => {
	const [scrollbarHeight, setScrollbarHeight] = useState(0);
	const appliedHeightRef = useRef(DEFAULT_TAGS_TABLE_HEIGHT);

	useEffect(() => {
		const panel = panelRef.current;
		if (!panel || panel.isCollapsed()) return;

		const currentHeight = panel.getSize().inPixels;
		const isStillDefault =
			Math.abs(currentHeight - appliedHeightRef.current) <= SIZE_TOLERANCE_PX;
		if (!isStillDefault) return;

		const defaultHeight = DEFAULT_TAGS_TABLE_HEIGHT + scrollbarHeight;
		panel.resize(defaultHeight);
		appliedHeightRef.current = defaultHeight;
	}, [scrollbarHeight, panelRef]);

	return setScrollbarHeight;
};
